// Copyright (c) 2017 Deere & Company

import AuditStatus from '@deere/cps-it.warranty-model-factory/lib/audit-status';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetAuditStatus = () => getDefaultState().auditStatus;

const updateAuditStatus = (state, action) =>
    AuditStatus.update(state, {
        $set: action.data
    });

export default (state = getDefaultState().auditStatus, action) => {

    const actionTypes = {
        [actions.RESET_AUDIT_STATUS_REPORT]: resetAuditStatus,
        [actions.UPDATE_AUDIT_STATUS_REPORT]: updateAuditStatus
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/audit-status/reducers/audit-status.js